// WHAT: Hook für den Zugriff auf den ProgressContext
// WHY:  Auslagerung des Hooks in eigene Datei, damit die Context-Datei selbst nur Komponenten exportiert

import { useContext } from "react";

import { ProgressContext } from "./ProgressContext.shared";

export const useGlobalProgress = () => {
  const context = useContext(ProgressContext);
  if (!context) {
    throw new Error("useGlobalProgress must be used within ProgressProvider");
  }
  return context;
};
